<script setup>
import { Link, usePage } from "@inertiajs/vue3";
import { useEventEmitter } from "@/composables/useEventEmitter";

useEventEmitter();
</script>

<template>
  <div class="skin-typography">
    <div class="h-16 flex items-center justify-center bg-white">
      <div>
        <Link href="/">
          <img class="h-12 w-auto fill-current text-gray-500" :src="$page.props.logo" alt="logo">
        </Link>
      </div>
    </div>
    <slot />
    <div class="bg-[#F8F8FD] text-[#ACB3CC] py-4 text-xs text-center flex flex-col gap-4">
      <div v-if="$page.props.logo_footer" class="flex items-center justify-center">
        <img class="h-12 w-auto fill-current text-gray-500" :src="$page.props.logo_footer" alt="logo">
      </div>
      <div>
        <p>Tech solution provided by Performing Digital SRL</p>
      </div>
    </div>
  </div>
</template>


<style>
  body, html {
    background-color: #fff;
  }
</style>
